import { request } from './request';

//
export const getHomeList = async (params = {}, options = {}) => {
    const data = await request.get('/v1/square', params, options);

    return data;
};

export const createTask = async (params = {}, options = {}) => {
    const data = await request.post('/v1/tasks', params, options);

    return data;
};

//   删除任务
export const deleteTask = async (params = {}, options = {}) => {
    const { id } = params;
    const data = await request.delete(`/v1/tasks/${id}`, {}, options);

    return data;
};

// 取消任务
export const cancelTask = async (params = {}, options = {}) => {
    const { id } = params;
    const data = await request.post(`/v1/tasks/${id}/cancel`, {}, options);

    return data;
};

//  升级加速
export const upgradeTask = async (params = {}, options = {}) => {
    const { id } = params;
    const data = await request.post(`/v1/tasks/${id}/upgrade`, {}, options);
    return data;
};

// 收藏
export const collect = async (params = {}, options = {}) => {
    const { id } = params;
    const data = await request.post(`/v1/square/${id}/like`, {}, options);

    return data;
};

// 取消收藏
export const unCollect = async (params = {}, options = {}) => {
    const { id } = params;
    const data = await request.post(`/v1/square/${id}/unlike`, {}, options);

    return data;
};

// 详情
export const mediaDetails = async (params = {}, options = {}) => {
    const { id } = params;
    const data = await request.get(`/v1/square/${id}`, {}, options);

    return data;
};
